import { render, staticRenderFns } from "./CreateAudit.vue?vue&type=template&id=8b45ea46&"
import script from "./CreateAudit.vue?vue&type=script&lang=ts&"
export * from "./CreateAudit.vue?vue&type=script&lang=ts&"
import style0 from "./CreateAudit.vue?vue&type=style&index=0&id=8b45ea46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports